/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useIntl} from 'react-intl'
import {
  User,
  initialUser as initialValues,
} from '../../../../app/pages/applicationsView/core/_models'
import {useFormik} from 'formik'
import Swal from 'sweetalert2'
import axios from 'axios'
import * as Yup from 'yup'
import {Logout, useAuth} from '../../../../app/modules/auth'
import {useNavigate} from 'react-router-dom'
const API_URL = process.env.REACT_APP_API_URL || 'api'

const measurementSchema = Yup.object().shape({
  //value: Yup.string().required('Campo obrigatório'),
})

const EditImagePerfil: FC = () => {
  const {logout} = useAuth()
  const navigate = useNavigate()
  const intl = useIntl()
  // const location = useLocation()
  // const navigate = useNavigate()
  //BUSCA TOKEN NO LOCALSTORAGE
  const response = localStorage.getItem('user_storage')
  const userResponse = JSON.parse(response || '{}')
  const user = userResponse.response

  const token = localStorage.getItem('auth_storage')
  const timestamp = new Date().getTime()
  const [defaultImage, setDefaultImage] = useState(
    user.picture ? user.picture + '?' + timestamp : toAbsoluteUrl('/media/avatars/blank.png')
  )
  const [hint, setHint] = useState(user ? 'Imagem ' + user.username : '')
  const [loading, setLoading] = useState(false)

  const [image, setImage] = useState(defaultImage ?? '')
  const [File, setFile] = useState<File | null>(null)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = () => {
        setImage(reader.result as string)
      }
      reader.readAsDataURL(file)
      setFile(file)
    }
  }

  const handleCancelClick = () => {
    setImage(defaultImage ?? '')
    setFile(null)
  }

  const handleRemoveClick = () => {
    setImage('')
    setFile(null)
  }

  const datasend = new FormData() //formdata object
  const formik = useFormik<User>({
    initialValues,
    validationSchema: measurementSchema,
    onSubmit: async (values) => {
      if (!File) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'COMMON.SELECT_IMAGE'}),
          showConfirmButton: false,
          timer: 1000,
        })
        return
      }
      setLoading(true)
      if (user.uuid) datasend.append('uuid', user.uuid)
      if (File) datasend.append('picture', File)
      try {
        await axios({
          method: 'post',
          url: `${API_URL}/v1/users/change_image_profile/${user.uuid}`,
          data: datasend,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PARAMETERS.SWAL_EDIT'}),
          showConfirmButton: false,
          timer: 1000,
        })
        fecharModal()
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PARAMETERS.SWAL_EDIT_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  function fecharModal() {
    const modal = document.querySelector('#kt_modal_editImagePerfil')
    if (modal) modal.classList.remove('show')

    document.body.classList.remove('modal-open')
    const modalBackdrop = document.querySelector('.modal-backdrop')
    if (modalBackdrop) modalBackdrop.remove()

    //FAZ LOGOUT NO SISTEMA
    window.location.reload()
  }

  return (
    <div className='modal fade' id='kt_modal_editImagePerfil' aria-hidden='true'>
      <div className='modal-dialog mw-250px'>
        <div className='modal-content rounded'>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <div
              className='btn btn-sm btn-icon btn-active-color-primary mt-n6'
              data-bs-dismiss='modal'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
            </div>
          </div>
          {/* // begin::Form */}

          <form onSubmit={formik.handleSubmit} noValidate className='form'>
            <div className='row mb-2'>
              <label className='col-lg-12 text-center col-form-label fw-bold fs-6'>
                Editar imagen do perfil
              </label>
              <div className='col-lg-12 mx-18'>
                <div
                  className='image-input image-input-outline '
                  data-kt-image-input='true'
                  style={{backgroundImage: `url(${defaultImage ?? ''})`}}
                >
                  <div
                    className='image-input-wrapper w-125px h-125px'
                    style={{backgroundImage: `url(${image})`}}
                  >
                    <label
                      className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                      data-kt-image-input-action='change'
                      data-bs-toggle='tooltip'
                      title='Alterar avatar'
                    >
                      <i className='bi bi-pencil-fill fs-7'></i>
                      <input
                        type='file'
                        name='avatar'
                        accept='.png'
                        onChange={handleFileChange}
                        hidden
                      />
                    </label>
                    {image !== defaultImage && (
                      <>
                        <span
                          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                          data-kt-image-input-action='cancel'
                          data-bs-toggle='tooltip'
                          title='Cancelar'
                          onClick={handleCancelClick}
                        >
                          <i className='bi bi-x fs-2'></i>
                        </span>
                        <span
                          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                          data-kt-image-input-action='remove'
                          data-bs-toggle='tooltip'
                          title='Remove avatar'
                          onClick={handleRemoveClick}
                        >
                          <i className='bi bi-x fs-2'></i>
                        </span>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-lg-12 text-center'>
                {hint && (
                  <div className='form-text text-primary text-center fs-8 fw-bold'>{hint}</div>
                )}
              </div>
            </div>

            {/* // end::Form */}
            <div className='d-flex justify-content-end py-2 px-2'>
              <button type='submit' className='btn btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>

            <div className='modal-body pt-0 pb-5 px-5 px-xl-20'></div>
          </form>
        </div>
      </div>
    </div>
  )
}

export {EditImagePerfil}
